export function validateMessage(messageImage, selectedImageFile, msgContent) {
    if (messageImage.trim() === '' && msgContent.trim() === '') {
        return { loading: false, error: true, message: "An image file or message is required." };
    }

    if (selectedImageFile) {
        if (selectedImageFile.size > 10000000) {
            return { loading: false, error: true, message: "The image size is too large" };
        }

        if (selectedImageFile.type !== "image/png" && selectedImageFile.type !== "image/jpeg") {
            return { loading: false, error: true, message: "Only jpg and png image files are accepted" };
        }
    }

    if (msgContent.trim() !== '' && msgContent.length <= 10) {
        return { loading: false, error: true, message: "We don't accept messages that short" };
    }

    return { loading: true, error: false, message: "" }; // Valid case
}
